'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = {
  setSPM: function setSPM(spmA, spmB) {
    return function (WrappedComponent) {
      var SetSpm = function (_Component) {
        _inherits(SetSpm, _Component);

        function SetSpm() {
          _classCallCheck(this, SetSpm);

          return _possibleConstructorReturn(this, (SetSpm.__proto__ || Object.getPrototypeOf(SetSpm)).apply(this, arguments));
        }

        _createClass(SetSpm, [{
          key: 'render',
          value: function render() {
            return React.createElement(WrappedComponent, this.props);
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (window.$ACE) {
              window.$ACE.Tracker.setPageSPM(spmA, spmB);
            }
          }
        }]);

        return SetSpm;
      }(_react.Component);

      return SetSpm;
    };
  },
  spmC: function spmC(_spmC) {
    return function (WrappedComponent) {
      var SpmC = function (_Component2) {
        _inherits(SpmC, _Component2);

        function SpmC() {
          _classCallCheck(this, SpmC);

          return _possibleConstructorReturn(this, (SpmC.__proto__ || Object.getPrototypeOf(SpmC)).apply(this, arguments));
        }

        _createClass(SpmC, [{
          key: 'render',
          value: function render() {
            var name = WrappedComponent.displayName || WrappedComponent.name || 'Component';
            return React.createElement(
              'div',
              { 'data-spm': _spmC ? _spmC : name },
              React.createElement(WrappedComponent, this.props)
            );
          }
        }]);

        return SpmC;
      }(_react.Component);

      return SpmC;
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/react-util/lib/tracker.js
// module id = 457
// module chunks = 13 14 17 18 19 20 21 22 23 24 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 58 60